module.exports = __webpack_public_path__ + "img/unitPriceEvaluation_01.b2f59fd9.png";